import { useEffect } from "react";

export const onRoomBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = "Leave this call?";
};

export function useRoomLeaveProtection(enabled: boolean): void {
    useEffect(() => {
        if (!enabled) return undefined;

        window.addEventListener("beforeunload", onRoomBeforeUnload);
        return () => window.removeEventListener("beforeunload", onRoomBeforeUnload);
    }, [enabled]);
}
